import React, { createContext, useContext, useMemo, useState } from 'react';
const SubmitStatusContext = /*#__PURE__*/createContext(undefined);
export const SubmitStatusProvider = _ref => {
  let {
    children
  } = _ref;
  const [submitSuccessMessage, setSubmitSuccessMessage] = useState();
  const [submitFailureCode, setSubmitFailureCode] = useState();
  const [submitFailureMessage, setSubmitFailureMessage] = useState();
  const value = useMemo(() => ({
    submitSuccessMessage,
    submitFailureCode,
    submitFailureMessage,
    setSubmitSuccessMessage,
    setSubmitFailureCode,
    setSubmitFailureMessage
  }), [submitSuccessMessage, submitFailureCode, submitFailureMessage]);
  return /*#__PURE__*/React.createElement(SubmitStatusContext.Provider, {
    value: value
  }, children);
};
export const useSubmitStatus = () => {
  const context = useContext(SubmitStatusContext);
  if (context === undefined) {
    throw new Error('useSubmitStatus must be used within a SubmitStatusProvider');
  }
  return context;
};
//# sourceMappingURL=submit-status-context.js.map